import { useState } from "react";
import type { SignUpData } from "types/auth";
import "styles/cadastro.css";
import { useTranslation } from "react-i18next";

type Props = {
  data: SignUpData;
  onNext: (p: Partial<SignUpData>) => void;
  onBack: () => void;
};

export default function StepLocalFixo({ data, onNext, onBack }: Props) {
  const { t } = useTranslation();

  const [possui, setPossui] = useState<boolean>(data.possuiLocalFixo ?? false);
  const [nome, setNome] = useState(data.destinoFixoNome ?? "");
  const [pais, setPais] = useState(data.destinoFixoPais ?? "");
  const [estado, setEstado] = useState(data.destinoFixoEstado ?? "");
  const [cidade, setCidade] = useState(data.destinoFixoCidade ?? "");
  const [rua, setRua] = useState(data.destinoFixoRua ?? "");
  const [cep, setCep] = useState(data.destinoFixoCEP ?? "");
  const [telefone, setTelefone] = useState(data.destinoFixoTelefone ?? "");

  const continuar = () => {
    onNext({
      possuiLocalFixo: possui,
      destinoFixoNome: possui ? nome : "",
      destinoFixoPais: possui ? pais : "",
      destinoFixoEstado: possui ? estado : "",
      destinoFixoCidade: possui ? cidade : "",
      destinoFixoRua: possui ? rua : "",
      destinoFixoCEP: possui ? cep : "",
      destinoFixoTelefone: possui ? telefone : "",
    });
  };

  return (
    <div>
      <h3 className="font-semibold text-lg mb-1">{t("fields.local_fixo_title")}</h3>
      <p className="text-sm text-gray-500 mb-4">{t("fields.local_fixo_subtitle")}</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
        <button
          type="button"
          onClick={() => setPossui(false)}
          className={`text-left border rounded-lg p-4 transition-colors hover:border-brand-primary ${
            !possui ? "border-brand-primary bg-brand-primary/5" : "border-gray-300"
          }`}
        >
          <p className="font-semibold text-sm">{t("fields.local_fixo_nao")}</p>
        </button>
        <button
          type="button"
          onClick={() => setPossui(true)}
          className={`text-left border rounded-lg p-4 transition-colors hover:border-brand-primary ${
            possui ? "border-brand-primary bg-brand-primary/5" : "border-gray-300"
          }`}
        >
          <p className="font-semibold text-sm">{t("fields.local_fixo_sim")}</p>
        </button>
      </div>

      {possui && (
        <div className="cadastro-grid-campos mb-4">
          <div className="cadastro-campo col-span-2">
            <label className="cadastro-rotulo">{t("fields.destino_fixo_nome")}</label>
            <input className="cadastro-entrada" value={nome} onChange={(e) => setNome(e.target.value)} />
          </div>
          <div className="cadastro-campo">
            <label className="cadastro-rotulo">{t("fields.country")}</label>
            <input className="cadastro-entrada" value={pais} onChange={(e) => setPais(e.target.value)} />
          </div>
          <div className="cadastro-campo">
            <label className="cadastro-rotulo">{t("fields.state")}</label>
            <input className="cadastro-entrada" value={estado} onChange={(e) => setEstado(e.target.value)} />
          </div>
          <div className="cadastro-campo">
            <label className="cadastro-rotulo">{t("fields.city")}</label>
            <input className="cadastro-entrada" value={cidade} onChange={(e) => setCidade(e.target.value)} />
          </div>
          <div className="cadastro-campo">
            <label className="cadastro-rotulo">{t("fields.zip")}</label>
            <input className="cadastro-entrada" value={cep} onChange={(e) => setCep(e.target.value)} />
          </div>
          <div className="cadastro-campo col-span-2">
            <label className="cadastro-rotulo">{t("fields.street")}</label>
            <input className="cadastro-entrada" value={rua} onChange={(e) => setRua(e.target.value)} />
          </div>
          <div className="cadastro-campo col-span-2">
            <label className="cadastro-rotulo">{t("fields.phone")}</label>
            <input className="cadastro-entrada" value={telefone} onChange={(e) => setTelefone(e.target.value)} />
          </div>
        </div>
      )}

      <div className="cadastro-acoes">
        <button type="button" className="cadastro-btn-ghost" onClick={onBack}>
          {t("buttons.back")}
        </button>
        <button type="button" className="cadastro-btn-primario" onClick={continuar}>
          {t("buttons.continue")}
        </button>
      </div>
    </div>
  );
}
